import React from 'react';
import { Link } from 'react-router-dom';

const Breadcrumb = ({ items }) => {
  return (
    <nav className="flex items-center gap-2 text-sm mb-8">
      {items.map((item, index) => (
        <React.Fragment key={index}>
          {index > 0 && (
            <i className="fas fa-chevron-right text-gray-600 text-xs"></i>
          )}
          {item.path ? (
            <Link
              to={item.path}
              className="text-gray-400 hover:text-yellow-400 transition-colors"
            >
              {item.label}
            </Link>
          ) : (
            <span className="text-white font-medium">{item.label}</span>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
};

export default Breadcrumb;
